import Store from '@copilot/common/store/storeClass';
import { CampaignManager } from '@copilot/data';
import { CampaignActions } from '@copilot/common/store/actions/campaign';
import notificationManager from '@copilot/common/utils/notificationManager';

export const CampaignSettingsLabels = {
    DeleteLabel: 'Delete Campaign',
    DeleteConfirm: 'Are you sure you want to delete this campaign?',
};

/**
 * Deletes the given campaign
 *
 * @param campaignId campaign we are updating the colour for
 * @param colorHex hex value of the colour to change to
 */
export const deleteCampaign = (campaignId: string, deleteCampaignCallback?: () => void) => {
    CampaignManager.deleteCampaign(campaignId)
        .then(() => {
            Store.Dispatch(CampaignActions.deleteCampaign({ id: campaignId }));
            notificationManager.showSuccessNotification({
                message: 'Campaign Deleted',
                description: 'Campaign has been deleted.',
            });
            deleteCampaignCallback?.();
        })
        .catch(() => {
            notificationManager.showErrorNotification({
                message: 'Failed',
                description: 'Please refresh the page and try again',
            });
        });
};
